export default __webpack_public_path__ + "static/media/users.6b2ed1c0.svg";